import React, { useState } from 'react';
import Navbar from '../BasicLayout/Navbar/Navbar';

import styles from './SideBarLayout.module.scss';
import Footer from '../BasicLayout/Footer/Footer';
import { Col, Container, Row } from 'react-bootstrap';
import { useScrollRestoration } from 'common/hooks/useScrollRestoration';

export default function SideBarLayout(props) {
    const { children, rightBar, leftBar, useWhiteLogo, titlePage } = props;
    const scrollRef = useScrollRestoration();
    const [isScrolled, setIsScrolled] = useState(false);

    const handleScroll = (e) => {
        const scrollTop = e.target.scrollTop;
        if (!isScrolled && scrollTop > 10) {
          setIsScrolled(true);
        } else if (isScrolled && scrollTop < 10) {
          setIsScrolled(false);
        }
    };
      
    return (
        <div className='d-flex flex-column vh-100 vw-100 overflow-auto' ref={scrollRef} onScroll={handleScroll}>
            <Navbar isScrolled={isScrolled} useWhiteLogo={useWhiteLogo} titlePage={titlePage}/>
            <main id='main' className={`d-flex flex-column flex-grow-1 ${styles.main} m-0`}>
                <Container>
                    <Row className={`mt-5 ${styles.main_row} m-0`}>
                        {
                            leftBar && (
                                <Col lg={3} md={12} className={`order-3 order-lg-1`}>
                                    <div>
                                        {leftBar}
                                    </div>
                                    
                                </Col>
                            )
                        }

                        <Col lg={leftBar && !rightBar ? 9 : !leftBar && rightBar ? 9 : leftBar && rightBar ? 6 : !leftBar && !rightBar && 12} md={12} className="order-2">
                            {children}
                        </Col>

                        {
                            rightBar && (
                                <Col lg={3} md={12} className={`order-1 order-lg-3`}>
                                    <div>
                                        {rightBar}
                                    </div>
                                </Col>
                            )
                        }
                    </Row>
                </Container>
            </main>
            <Footer />
        </div>
    );
}
